import { supabase } from "@/integrations/supabase/client";

export type SlackNotifyPayload = {
  type:
    | "demo"
    | "meeting"
    | "application"
    | "comment"
    | "follow"
    | "signup"
    | "reset_password"
    | "roi"
    | "contact"
    | string;
  title: string;
  fields?: Record<string, string | number | boolean | null | undefined>;
  url?: string;
};

/**
 * Fire-and-forget Slack notification. Never throws; failures are logged only.
 * Posts to the #gh-hostcall-ai channel via the slack-notify edge function.
 */
export function notifySlack(payload: SlackNotifyPayload): void {
  try {
    // Strip empty fields for a cleaner Slack message.
    const cleanFields = payload.fields
      ? Object.fromEntries(
          Object.entries(payload.fields).filter(
            ([, v]) => v !== undefined && v !== null && v !== "",
          ),
        )
      : undefined;

    void supabase.functions
      .invoke("slack-notify", { body: { ...payload, fields: cleanFields } })
      .catch((err) => {
        console.warn("slack-notify failed:", err?.message ?? err);
      });
  } catch (err) {
    console.warn("slack-notify dispatch error:", err);
  }
}
